/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 */
function displayMessageAndChangeIcon(data, icon) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = "alert-success";
        if (icon.hasClass("cwf-star-empty")) {
            icon.removeClass("cwf-star-empty").addClass("cwf-star");
        }
    } else {
        status = "alert-danger";
    }

    if ($(".add-to-wishlist-messages").length === 0) {
        if ($(window).width() > 992) { // NOSONAR
            $("body").append("<div class=\"add-to-wishlist-messages \"></div>");
        } else {
            $("body").append("<div class=\"add-to-wishlist-messages \"></div>");
        }
    }
    $(".add-to-wishlist-messages")
        .append("<div class=\"add-to-wishlist-alert text-center " + status + "\">" + data.msg + "</div>");

    setTimeout(function () {
        $(".add-to-wishlist-messages").remove();
    }, 5000);
}

module.exports = {
    addToWishlist: function () {
        $("body").on("click", ".wishlistTile", function (e) {
            e.preventDefault();
            var icon = $(this).find($("i"));
            var url = $(this).attr("href");
            var pid = $(this).closest(".product").data("pid");
            var optionId = $(this).closest(".product-detail").find(".product-option").attr("data-option-id");
            var optionVal = $(this).closest(".product-detail").find(".options-select option:selected").attr("data-value-id");
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }

            $.spinner().start();
            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    displayMessageAndChangeIcon(data, icon);
                },
                error: function (err) {
                    displayMessageAndChangeIcon(err, icon);
                }
            });
        });
    },
    showWishlistedItems: function () {
        $(window).on("load", function () {
            $.ajax({
                url: $(".js-link-wishlist").data("wishlist-url"),
                type: "get",
                dataType: "json",
                success: function (data) {
                    if (data && data.list && data.list.items && data.list.items.length) {
                        $(".js-link-wishlist").attr("data-wishlist-items", data.list.items.map(item => item.pid));
                        var wishListedItems = $(".js-link-wishlist").attr("data-wishlist-items");
                        wishListedItems.split(",").forEach(function (item) {
                            //Update each tile with wishlist status
                            var productTile = $("[data-pid='" + item + "']");
                            if (productTile.length) {
                                productTile.find(".wishlistTile i").removeClass("cwf-star-empty").addClass("cwf-star");
                            }
                        });
                    } else if(data.list.items.length ===0) {
                        $(".js-link-wishlist").attr("data-wishlist-items", "");
                    }
                }
            });
        });
    }
};
